<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  mounted() {
  },
  unmounted() {
  },
  methods: {}
}
</script>

<style>
html, body, #app{
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.button{
  padding: 2px 8px;
  font-size: 14px;
  border-radius: 3px;
  border: 1px solid #999;
  cursor: pointer;
}
.button:hover{
  opacity: 0.8;
}
.not-overflow{
  overflow: hidden;
}
</style>
